
import { useState } from 'react';

const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  const phoneNumber = '34680254236';
  const message = encodeURIComponent('Hola, me gustaría solicitar información sobre instalaciones fotovoltaicas.');

  return (
    <>
      {/* Badge flotante sobre el asistente — esquina inferior izquierda */}
      <div
        className="fixed z-[9999] flex flex-col items-center pointer-events-none"
        style={{ bottom: '88px', left: '16px' }}
      >
        <span
          className="bg-[#FFB800] text-gray-900 font-extrabold px-4 py-2 rounded-full whitespace-nowrap shadow-xl tracking-tight"
          style={{
            fontSize: '15px',
            animation: 'assistant-float 2.5s ease-in-out infinite',
            letterSpacing: '-0.01em',
          }}
        >
          ⚡ Respondemos en menos de 1 minuto &nbsp;·&nbsp; 📅 Agenda tu cita
        </span>
        {/* Flechita apuntando al asistente */}
        <span
          style={{
            width: 0,
            height: 0,
            borderLeft: '8px solid transparent',
            borderRight: '8px solid transparent',
            borderTop: '8px solid #FFB800',
            marginTop: '-1px',
            alignSelf: 'flex-start',
            marginLeft: '28px',
          }}
        />
      </div>

      {/* Botón WhatsApp — esquina inferior derecha */}
      <a
        href={`https://wa.me/${phoneNumber}?text=${message}`}
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="fixed bottom-6 right-6 z-50 flex items-center gap-3 cursor-pointer group"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        aria-label="Contactar por WhatsApp"
      >
        <span
          className={`bg-white text-gray-800 text-sm font-medium px-4 py-2 rounded-full shadow-lg transition-all duration-300 whitespace-nowrap ${
            isHovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
          }`}
        >
          ¿Necesitas ayuda?
        </span>
        <span className="w-14 h-14 flex items-center justify-center bg-[#25D366] rounded-full shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300">
          <i className="ri-whatsapp-line text-white text-2xl"></i>
        </span>
      </a>

      <style>{`
        @keyframes assistant-float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-7px); }
        }
      `}</style>
    </>
  );
};

export default WhatsAppButton;
